import { createSlice } from '@reduxjs/toolkit'

export const idSlice = createSlice({
  name: 'id',
  initialState: {
    value: ''
  },
  reducers: {
    updateID: (state, action) => {
      state.value = action.payload;
    }
  }
})

export const { updateID } = idSlice.actions

export const selectID = (state) => state.id.value

export default idSlice.reducer